import { Box, Flex, Grid, GridItem, Image } from '@chakra-ui/react';
import React from 'react';
import { useSignUpModel } from '../../models/SignUpModel';
import { PartnerAccountForm } from '../components/PartnerAccountForm';

export const SignUpPartnerPage: React.FC = () => {
  const { partner } = useSignUpModel();
  const partnerColor = partner?.style.bg_color ?? 'white';

  return (
    <Flex
      p="0px"
      m="0px"
      boxSizing="border-box"
      justifyContent="center"
      alignItems="center"
      w="100%"
      h="100%"
      background={[
        'transparent',
        'transparent',
        'transparent',
        `linear-gradient(90deg, ${partnerColor} 50%, white 50%) no-repeat`,
      ]}>
      <Grid
        maxW={'1000px'}
        p="0px"
        m="0px"
        w="full"
        h={['full', 'full', 'full', 'initial']}
        templateColumns={['1fr', '1fr', '1fr', '1fr 1fr']}
        templateRows={['1fr', '1fr', '1fr', '100px 1fr']}>
        <GridItem
          order={[3, 3, 3, 1]}
          backgroundColor={[partnerColor, partnerColor, partnerColor, 'transparent']}
          display="flex"
          alignItems={'center'}
          pr={['20px', '20px', '20px', '68px']}
          pl={['20px', '20px', '20px', '0px']}
          py={['20px', '20px', '20px', '0px']}>
          <Box maxW="160px" w="100%">
            {partner?.style.primary_logo?.download_url && (
              <Image h={['40px', '40px', '40px', '60px']} src={partner.style.primary_logo?.download_url}></Image>
            )}
          </Box>
        </GridItem>
        <GridItem
          order={[1, 1, 1, 2]}
          display="flex"
          alignItems={'center'}
          pl={['20px', '20px', '20px', '68px']}
          pr={['20px', '20px', '20px', '0px']}
          pt={['30px', '30px', '30px', '0px']}
          pb={['40px', '40px', '40px', '0px']}>
          <Box maxW="160px" w="100%">
            <Image h={['32px', '32px', '32px', '45px']} src="/assets/gfx/logo-black.svg" />
          </Box>
        </GridItem>
        <GridItem
          order={[4, 4, 4, 3]}
          backgroundColor={[partnerColor, partnerColor, partnerColor, 'transparent']}
          pr={['20px', '20px', '20px', '68px']}
          pl={['20px', '20px', '20px', '0px']}
          pb={['30px', '30px', '30px', '0px']}
          display="flex"
          flexDir={'column'}>
          <Flex dangerouslySetInnerHTML={{ __html: partner?.style.html ?? '' }} />
        </GridItem>
        <GridItem
          order={[2, 2, 2, 4]}
          pl={['20px', '20px', '20px', '68px']}
          pr={['20px', '20px', '20px', '0px']}
          pb={['40px', '40px', '40px', '0px']}
          flexDir={'column'}
          display="flex"
          alignItems="center">
          <PartnerAccountForm />
        </GridItem>
      </Grid>
    </Flex>
  );
};
